export default {
  "icon-arrow-container": "_icon-arrow-container_1r4h7t",
  "disclaimer": "_disclaimer_1r4h7t"
};
